import { ZodType, z } from "zod";

export type WithClassName = {
  className?: string;
};

export const FormsWrapper = <T extends ZodType>(data: T) =>
  z.object({
    forms: z.array(data),
  });

export type FormsWrapper<T> = {
  forms: T;
};

export type Prettify<T> = {
  [K in keyof T]: T[K];
  // eslint-disable-next-line @typescript-eslint/ban-types
} & {};

export type PickFieldsByValueType<T, ValueType> = {
  [Key in keyof T as T[Key] extends ValueType ? Key : never]: T[Key];
};
